import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { MENU_ID, SIDEBAR_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { GENERIC_PROJECT_HORIZONTAL_NAV } from '@atlassian/jira-navigation-apps-horizontal-nav-selector/src/constants.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import { getServiceDeskSettingsResources } from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { projectSettingsServicedeskIssuetypesWorkflowRoute } from '@atlassian/jira-router-routes-project-settings-product-routes-service-desk-routes/src/projectSettingsServicedeskIssuetypesWorkflowRoute.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { jiraSpaResources } from '@atlassian/jira-router-resources-spa-page-container/src/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { chromelessLayout } from '@atlassian/jira-chromeless-layout/src/index.tsx';
import { expValEquals } from '@atlassian/jira-feature-experiments';
import { workflowBuilderProvisioningResource } from '@atlassian/jira-router-resources-admin-pages-workflow-builder-provisioning/src/index.tsx';
import { LazyIssueTypeSettings } from './ui/issue-type/index.tsx';
import WorkflowNavigationPage, {
	LazyWorkflowNavigationSettings,
} from './ui/workflow-navigation/index.tsx';

const getWorkflowBuilderProvisioningResources = () => [workflowBuilderProvisioningResource];

export const projectSettingsServicedeskIssuetypesWorkflowRouteEntry = createEntry(
	projectSettingsServicedeskIssuetypesWorkflowRoute,
	() => ({
		group: 'project-settings-servicedesk',
		component: WorkflowNavigationPage,

		layout: expValEquals('hix-7127_wfe_layout_to_chromeless_for_service', 'isEnabled', true, false)
			? chromelessLayout
			: serviceProjectLayout,

		navigation: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? undefined
			: {
					horizontal: GENERIC_PROJECT_HORIZONTAL_NAV,
					menuId: MENU_ID.PROJECTS,
					sidebar: AsyncSidebarServicedesk,
					sidebarId: SIDEBAR_ID.PROJECT_SETTINGS,
				},

		resources: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? [
					projectContextResource,
					...jiraSpaResources(),
					rovoEntitlementResource,
					...getWorkflowBuilderProvisioningResources(),
				]
			: [
					...getServiceDeskSettingsResources(),
					...getWorkflowBuilderProvisioningResources(),
					getConsolidationStateResource(),
				],

		forPaint: expValEquals(
			'hix-7127_wfe_layout_to_chromeless_for_service',
			'isEnabled',
			true,
			false,
		)
			? [LazyWorkflowNavigationSettings]
			: [LazyAtlassianNavigation, LazyIssueTypeSettings],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-project-settings-product-routes-service-desk-entries/src/projectSettingsServicedeskIssuetypesWorkflowRouteEntry.tsx',
				whichExportToUse: 'projectSettingsServicedeskIssuetypesWorkflowRouteEntry',
			},

			enabled: true,
		},
	}),
);
